// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JCIi","colBig":"styles_colBig__2H8mQ","colSmall":"styles_colSmall__LySDD"};